<template>
  <div
    data-testid="signin-app"
    data-bs-theme="dark"
    class="signin"
  >
    <router-view
      name="sidebar"
      data-testid="signin-nav"
    />

    <div class="signin__content">
      <router-view name="content" />
    </div>

    <CopyrightFooter />
    <SvgIconsSprite />
  </div>
</template>

<script>
import SvgIconsSprite from '../SvgIconsSprite.vue'
import CopyrightFooter from 'components/elements/CopyrightFooter.vue'

export default {
  components: {
    SvgIconsSprite,
    CopyrightFooter
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

.signin {
  &__content {
    margin-top: 1rem;
    padding: 2rem;
    background-color: $grey-30;
    border-radius: 8px;
  }
}
</style>

